import React, { useEffect, useState, useRef } from 'react';
import 'react-phone-number-input/style.css';
import PhoneInput, { getCountries } from 'react-phone-number-input';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import axiosClient from '../../../axios-client.js';
import RadioContainerLang from '../../components/lang/RadioContainerLang';
import RadioContainerTemplate from '../../components/template/RadioContainerTemplate';
import ConfirmMessage from './ConfirmMessage';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import arrowDown from '../../assets/svg/arrow-down.svg';
import icPhone from '../../assets/svg/ic-hone-div.svg';
import GenericInfos from './GenericInfos';
import icWhatsapp from '../../assets/svg/btn/whatsapp.svg';
import icLangCard from '../../assets/svg/steps/card/ic-lang-card.svg';
import icTemplateCard from '../../assets/svg/steps/card/ic-template-card.svg';
import icWhatsappCard from '../../assets/svg/steps/card/ic-whatsapp-card.svg';
import nextBtn from '../../assets/svg/btn/next-btn.svg'
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { FormControlLabel, FormGroup, Switch } from '@mui/material';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import InfoIcon from '@mui/icons-material/Info';
import { useOutletContext } from 'react-router-dom';
import { Helmet } from 'react-helmet';


const NewMessage = () => {

  const [templateId, setTemplateId] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedLangId, setSelectedLangId] = useState();
  const [selectedTemplateId, setSelectedTemplateId] = useState();
  const [inputValues, setInputValues] = useState({});
  const [selectedCountry, setSelectedCountry] = useState();
  const [selectedCountryFlag, setSelectedCountryFlag] = useState();
  const [phone, setPhone] = useState();
  const [showModal, setShowModal] = useState(false);
  const [ isSuccess, setSuccess ] = useState([ false ]);
  const { credits, setCredits } = useOutletContext();
  const [flowId, setFlowId] = useState();
  const [countryId, setCountryId] = useState();
  const [inputValName, setInputValName] = useState(null);
  const [country, setCountry] = useState('MA')
  const [isValid, setIsValid] = useState(false);
  const [isValidion, setIsValidion] = useState(true);
  const [isHasEmptyField, setHasEmptyField] = useState(false)

  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFileVariable, setSelectedFileVariable] = useState();
  const [fileDataName, setFileDataName] = useState(null);
  const [templateAsFrom, setTemplateAsFrom] = useState(false);
  const [templateHasFllowForm, setTemplateHasFlow] = useState(false);
  const [sentAsForm, setSentAsFrom] = useState(false);

  const [hasflow, setHasFlow] = useState(false);
  const [ formFlow, setFormFlow ] = useState(false);
  
  const supportedCountries = getCountries().filter((code) => code !== 'EH');

  const [ metTitle, setMetaTitle ] = useState('');
  const [ metaDescription, setMetaDescription ] = useState('');
  
  const handleFileChange = (file, variable, name) => {
    setSelectedFileVariable(variable);
    setFileDataName(name);
    setSelectedFile(file);
  };


  const handleConfirmAction = (confirmedData) => {
    onSubmit(confirmedData);

  };


  const handleCloseModal = () => {
    setShowModal(false);
  };

  const notify = () => {
    toast.error('You don`t have enough credits in your balance to send your message.!', {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };

  const respMsg = (msg) => {
    toast.success(`${msg}`, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };

  const errMsg = (msg) => {
    toast.error(`${msg}`, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };

  const handleCountrySelect = (countryName, countryFlag, countryId, sflowId) => {
    setSelectedCountry(countryName);
    setSelectedCountryFlag(countryFlag);
    setCountryId(countryId);
    setFlowId(sflowId);
  };

  const handleLanguageSelect = async (langId) => {
    setFileDataName();
    setSelectedFile();
    setInputValues();
    setSelectedTemplateId();
    setTemplateId([]);
    setSelectedLangId(langId);
    setTimeout(() => {
      const gotoTemplate = document.getElementById('RadioContainerTemplate');
      if (gotoTemplate) {
        gotoTemplate.scrollIntoView({ behavior: 'smooth' });
      }
    }, 300);
  };

  const handleTemplateSelect = (templateSelected, hasflow, formFlow) => {
    setSelectedTemplateId(templateSelected);
    setHasFlow(hasflow);
    setFormFlow(formFlow);
    getTemplateId(templateSelected);
    setTimeout(() => {
      const goToContent = document.getElementById('content');
      if (goToContent) {
        goToContent.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const handleTemplateName = () => {

  }

  const updateFormData = (data) => {
    // console.log(data)
    const updatedData = {
      ...inputValues,
      ...data,
    };
    setInputValues(updatedData);
  };

  const onchangeNumber = (val) => {
    setPhone(val);
    if (val) {
      const parsedPhoneNumber = parsePhoneNumberFromString(val, country);
      setIsValid(parsedPhoneNumber ? parsedPhoneNumber.isValid() : false);
      setIsValidion(true)
      // console.log(isValid)
    }
  };


  const onSubmit = (e) => {
    
    const payload = {
      language_id: selectedLangId,
      name: phone,
      country_id: countryId,
      template_id: selectedTemplateId,
      phone: phone,
      data: inputValues,
      template_account_flow_id: flowId,
      // ...(sentAsForm ? { as_form: "on" } : {}),
    };

    if (hasflow && formFlow) {
      if (sentAsForm) {
        payload.as_form = "on";
      }
    } else if (!hasflow && formFlow) {
      payload.as_form = "on";
    }

    setLoading(true);



    if (selectedFile) {
      const formData = new FormData();
      var docfile = document.querySelector('#fileInput');
      formData.append(inputValName, docfile.files[0]);

      // Append the payload data
      formData.append('language_id', selectedLangId);
      formData.append('name', phone);
      formData.append('country_id', countryId);
      formData.append('template_id', selectedTemplateId);
      formData.append('phone', phone);

      const dataArray = Object.entries(inputValues).map(([key, value]) => ({ key, value }));

      dataArray.forEach(({ key, value }) => {
        const formattedKey = `data[${key}]`;
        const item = `${value}`;
        formData.append(formattedKey, item);
      });


      formData.append('template_account_flow_id', flowId);

      axiosClient.post(`/messages`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(({ data }) => {
          setLoading(false);
          setSuccess(data.data.success)
          userInfo();
          if (data.message) {
            respMsg(data.message);
          }
        })
        .catch((err) => {
          const response = err.response;
          if (response && response.status === 422) {
            errMsg(response.data.errors);
          } else if (response && response.status === 404) {
            errMsg(response.data.message);
          }
          setLoading(false);
        });
    } else {
      axiosClient.post('/messages?', payload).then(({ data }) => {
        setLoading(false);
        setSuccess(data.data.success)
        if (data.message) {
          respMsg(data.message);
        }
        userInfo();
      }).catch(err => {
          const response = err.response;
          if (response && response.status === 422) {
            errMsg(response.data.errors);
          } else if (response && response.status === 404) {
            errMsg(response.data.message);
          }
          setLoading(false);
        });
    }
  };

  const validateInputValues = () => {
    if (!selectedCountry) {
      alert('Please select your WhatsApp area code')
      return false;
    }

    if (!phone || !phone.trim()) {
      alert('Please enter the recipient number')
      return
    }

    return true;
  };

  useEffect(() => {
    userInfo();
    appSettings();
  }, [])

  const appSettings = () => {
    axiosClient.get('/app-settings')
      .then(({ data }) =>
      {
        setMetaTitle(data.data.title)
        setMetaDescription(data.data.description);
      })
      .catch(() =>
      {
        setLoading(false)
      })
  }

  const userInfo = () => {
    setLoading(true);
    axiosClient.get('/credits')
        .then(({ data }) => {
            console.log("Credits data:", data); // Log the data
            setLoading(false);
            setCredits(data.data.credit);
        })
        .catch(() => {
            setLoading(false);
        });
}

  const getTemplateId = async (stemplateId) => {
    setTemplateId([]);
    if (stemplateId) {
      setLoading(true);
      try {
        const response = await axiosClient.get(`/template/accounts?template_id=${stemplateId}`);
        const data = response.data.data;

        setLoading(false);
        setTemplateId(data);

        if (data.length > 0) {
          setSelectedCountryFlag(data[data.length - 1].country.flag);
          setSelectedCountry(data[data.length - 1].phone);
          setCountryId(data[data.length - 1].country.id);
          setFlowId(data[data.length - 1].template_account_flow_id)
          setSelectedTemplateId(stemplateId)
          setTemplateAsFrom(data[data.length - 1].has_form);
          setTemplateHasFlow(data[data.length - 1].has_flow);
        }
      } catch (error) {
        setLoading(false);
      }
    }
  };


  const onSend = () => {
    if (isHasEmptyField) {
      return
    }

    if (!isValid) {
      setIsValidion(false)
      return
    } else {
      setIsValidion(true)
    }
    if (!validateInputValues()) {
      return;
    }
    setShowModal(true);
  };


  const switchChange = (event) => {
    console.log(event.target.checked)
    setSentAsFrom(event.target.checked);
  };

  const handleAskForNewTemplate = () => {
    // Logic to ask for a new template
    console.log("Ask for New Template button clicked");
  };
  

  return (
    <>
      <Helmet>
        <title>New Message | { metTitle }</title>
        <meta name="description" content={ metaDescription } />
        <meta name="keywords" content="WhatsApp Business, Customer Service, Automations, Broadcasts, AI Chatbots, Lead Qualification" />
      </Helmet>
      <div className='container-fluid vh-75'>
        <ToastContainer />
        <form className='mb-5 bg-white mt-5 justify-content-center align-items-center rounded-25'>
          <div className='row justify-content-center align-items-center'>
            <div className='col-md-12 p-0'>
              <img className='d-flex mx-auto ic-card-msg-top' src={icLangCard} alt='' srcSet='' />
              <h1 className='text-center title my-4'>Choose your Language</h1>
              <div className='divider my-5'></div>
              <RadioContainerLang onClickLang={handleLanguageSelect} classInput={'d-none'} />
            </div>
            {
              selectedLangId ? <div className={`col-md-12 p-0`}>
                <div id='RadioContainerTemplate' className='divider my-5'></div>
                <img className='my-3 d-flex mx-auto ic-card-msg' src={icTemplateCard} alt='' srcSet='' />
                <div className="row">
                  <div className='col-md-4'></div>
                  <div className='col-md-4'><h1 className='text-center title my-4'>Choose your Template</h1></div>
                </div>
                <div className='divider my-5'></div>
                <RadioContainerTemplate isBroadcast={0} templateName={handleTemplateName} slidToshow={5} onClickTemplate={(templateSelected, hasflow, formFlow) => handleTemplateSelect(templateSelected, hasflow, formFlow)} idTemplate={selectedLangId !== null ? selectedLangId : 0} />

              </div> : <></>
            }

            {selectedTemplateId ? <div className={`col-md-12 p-0 pb-5`}>
              <GenericInfos
                inputValueName={setInputValName}
                onFileChange={handleFileChange}
                idLang={selectedLangId !== null ? selectedLangId : 0}
                templateSelected={selectedTemplateId != null ? selectedTemplateId : 0}
                updateFormData={updateFormData}
              />
            </div> : <></>
            }
            {selectedTemplateId ? <>
              <div className={`col-md-12 p-0`}>
                <div className='divider my-5'></div>
                <img className='my-3 d-flex mx-auto ic-card-msg' src={icWhatsappCard} alt='' srcSet='' />
                <h1 className='text-center title my-4'>WhatsApp Area Code</h1>
                <div className='divider my-5'></div>
                <div className='row justify-content-start align-items-center col-md-10 px-5 mt-5 mb-5'>
                  <h3 className='py-2'>Choose WhatsApp area code</h3>
                  <div className='col-md-5'>
                    <div className='whatsapp-input d-flex col-md-6 form-control rounded-pill justify-content-start align-items-center'>
                      <img width='18' className='arrow-phone' src={arrowDown} />
                      <DropdownButton className='bg-transparent border-0' title={ <img className='p-1' width={ 35 } src={ selectedCountryFlag } alt='' srcSet='' /> } id='dropdown-basic-button' variant=''>
                        {/* <Dropdown.Item onClick={handleAskForNewTemplate}>
                          <i className="fas fa-plus-circle me-2"></i> Ask for your own number
                        </Dropdown.Item>
                        <Dropdown.Divider /> */}
                        {templateId.map((item, index) => (
                          <Dropdown.Item key={index} onClick={() => handleCountrySelect(item.phone, item.country.flag, item.country.id, item.template_account_flow_id)}>
                            <img className='p-1' width={30} src={item.country.flag} alt='' srcSet='' />
                            <span>{item.phone}</span>
                          </Dropdown.Item>
                        ))}

                      </DropdownButton>
                      <div>
                        {selectedCountry}
                      </div>
                      <img className='ms-auto' height={30} src={icWhatsapp} />
                    </div>

                  </div>
                </div>
              </div>
              <div className='col-md-12 p-0'>
                <div className='divider my-5'></div>
                <img className='my-3 d-flex mx-auto ic-card-msg' src={icPhone} alt='' srcSet='' />
                <h1 className='text-center title my-4'>Client Number</h1>
                <div className='divider my-5'></div>

                <div className='row justify-content-start align-items-center col-md-10 px-5 mt-5 mb-5'>
                  <h3 className='py-2'>Client Number</h3>
                  <p className='pb-2'><span className='txt-green'>Congratulations.</span> You are ready to send your message. Put the Client Number to send the message.</p>

                  <div className='col-md-5'>
                    <div className={`${isValid ? 'border-success' : ''} bg-transparent d-flex col-md-6 form-control rounded-pill justify-content-start align-items-center`}>
                      <img width={18} className='arrow-phone' src={arrowDown} />
                      <PhoneInput
                        id={'phoneId'}
                        className='form-control border-0 bg-transparent rounded-pill'
                        placeholder='+212 669 47 00 00'
                        international
                        defaultCountry={country}
                        onCountryChange={(val) => setCountry(val)}
                        value={ phone }
                        countries={supportedCountries} 
                        onChange={(val) => onchangeNumber(val)}
                        countrySelectProps={{
                          unicodeFlags: true,
                        }}
                        countryCallingCodeEditable={true}
                      />
                    </div>
                    <div className={`${!isValidion ? 'd-block' : 'd-none'} alert alert-danger mt-2`} role="alert">Please enter a valid Whatsapp phone number !</div>
                    <div className={`${isHasEmptyField ? 'd-block' : 'd-none'} alert alert-danger mt-2`}>Please make sure all field requered is not empty</div>
                  </div>
                </div>
              </div>
              {hasflow && formFlow && (
                <FormGroup className="mb-4">
                  <FormControlLabel
                    className='m-auto'
                    control={<Switch checked={sentAsForm} onChange={switchChange} />}
                    label={
                      <>
                        Send as form
                        <OverlayTrigger placement='top' overlay={<Tooltip id='tooltip-info'>Choose "Send as form" to send the form version of the template.</Tooltip>}>
                          <InfoIcon className='ms-3' />
                        </OverlayTrigger>
                      </>
                    }
                  />
                </FormGroup>
              )}
              <div className='d-flex justify-content-center align-items-center border-0 rounded-pill p-1 text-center mb-5'>
                <span role='button' onClick={credits === 0 ? notify : isSuccess ? onSend : () => { }}
                  disabled={loading} variant='none' className='px-1 btn-primary d-flex justify-content-start align-items-center'>
                  {loading ? (
                    <span>Sending...</span>
                  ) : isSuccess != true ? (
                    <span>Send message</span>
                  ) : (
                    <span>Send another message</span>
                  )}
                  <img className='ic-btn' src={nextBtn} />
                </span>
              </div>

              <ConfirmMessage
                phoneNumber={phone}
                show={showModal}
                handleClose={handleCloseModal}
                onConfirm={handleConfirmAction}
                onSubmit={onSubmit}
              />
            </> : <></>}
          </div>
        </form>
      </div>
    </>
  );
};

export default NewMessage;
